export interface ArchiveCard {
  id: string;
  no: string;
  title: string;
  subject: string;
  tag: string;
  tagTone: 'primary' | 'accent' | 'secondary';
  brief: string;
  time: string;
  views: string;
}

export const latestArchives: ArchiveCard[] = [
  {
    id: 'a-01',
    no: '档案 · 004219',
    title: '主播「晚风几重」带货翻车始末',
    subject: '晚风几重',
    tag: '带货',
    tagTone: 'primary',
    brief: '直播间承诺“假一赔十”，事后售后口风反复，退货拉黑关键词陆续浮出水面，已整理链路图与时间点。',
    time: '今天 14:20',
    views: '6.2w',
  },
  {
    id: 'a-02',
    no: '档案 · 004218',
    title: '网红「一只柠檬」旧照考古',
    subject: '一只柠檬',
    tag: '网红',
    tagTone: 'accent',
    brief: '粉丝挖出三年前素人期旧照与访谈，人设口径前后对不上，平台方暂未回应，档案已归档留痕。',
    time: '今天 11:05',
    views: '4.8w',
  },
  {
    id: 'a-03',
    no: '档案 · 004217',
    title: '艺人「陆川叙」直播言论逐句复盘',
    subject: '陆川叙',
    tag: '艺人',
    tagTone: 'secondary',
    brief: '一段演出后台连线录音流传，涉及团队归属与档期争议，逐句转写与出处已按时间线排好。',
    time: '昨天 22:41',
    views: '9.1w',
  },
  {
    id: 'a-04',
    no: '档案 · 004216',
    title: '游戏主播「老K不K」违约金风波',
    subject: '老K不K',
    tag: '主播',
    tagTone: 'accent',
    brief: '跳槽停播后合同细节被曝光，原机构与现东家各执一词，仲裁进展已更新到本月节点。',
    time: '昨天 18:30',
    views: '3.9w',
  },
];

export interface FlashItem {
  id: string;
  time: string;
  cat: string;
  title: string;
  lead: string;
}

export const flashStream: FlashItem[] = [
  { id: 'f-01', time: '14:20', cat: '带货', title: '晚风几重售后口径再反转', lead: '客服内部话术截图流出，与直播间承诺“假一赔十”明显冲突。' },
  { id: 'f-02', time: '13:45', cat: '网红', title: '一只柠檬素人期访谈被扒', lead: '三年前旧访谈与现人设存在时间线对不上，话题冲上同城热榜。' },
  { id: 'f-03', time: '12:58', cat: '艺人', title: '陆川叙工作室发声明否认', lead: '声明称录音系剪辑拼凑，尚未公布完整版音频源。' },
  { id: 'f-04', time: '11:36', cat: '商战', title: '两家MCN互发律师函', lead: '围绕主播解约后直播权限归属，双方在社交平台隔空交锋。' },
  { id: 'f-05', time: '10:52', cat: '主播', title: '老K不K宣布下月复播', lead: '直播首站定在某平台年度盛典，违约仲裁仍在进行中。' },
  { id: 'f-06', time: '09:47', cat: '网红', title: '民宿探店博主“踩雷”翻车', lead: '被指摆拍与实测不符，评论区出现同款踩雷截图。' },
  { id: 'f-07', time: '08:30', cat: '主播', title: '连麦互撕后双方开播致歉', lead: '情绪化发言引热议，次日均公开道歉但未和解。' },
  { id: 'f-08', time: '昨天', cat: '艺人', title: '剧组番位海报被指P图', lead: '粉丝逐帧比对发现人像比例异常，片方暂无回应。' },
  { id: 'f-09', time: '昨天', cat: '带货', title: '羽绒服充绒量抽检存疑', lead: '第三方实验室测评与页面标注有出入，商家晒报告反驳。' },
  { id: 'f-10', time: '昨天', cat: '网红', title: '美食博主后厨卫生被曝', lead: '探店跟拍视角流出，商家称视频拍摄于停业整理时段。' },
  { id: 'f-11', time: '昨天', cat: '商战', title: '头部公会年终榜单存疑', lead: '数据方公开抽样结果，官方称规则解读差异导致误读。' },
  { id: 'f-12', time: '前天', cat: '主播', title: '户外主播“剧本式”求救引争议', lead: '一段摆拍求救被识破，主播承认失误并停播自省。' },
];

export const streamCats = ['全部', '网红', '主播', '艺人', '带货', '商战'];

export interface HotRow {
  id: string;
  rank: number;
  title: string;
  delta: 'up' | 'down' | 'flat';
  heat: string;
}

export const hotRank: HotRow[] = [
  { id: 'h-01', rank: 1, title: '陆川叙直播言论复盘', delta: 'up', heat: '9.1w' },
  { id: 'h-02', rank: 2, title: '晚风几重售后反转', delta: 'up', heat: '8.6w' },
  { id: 'h-03', rank: 3, title: '一只柠檬素人考古', delta: 'flat', heat: '7.4w' },
  { id: 'h-04', rank: 4, title: '老K不K违约金仲裁', delta: 'up', heat: '6.9w' },
  { id: 'h-05', rank: 5, title: '头部公会年终榜单', delta: 'down', heat: '6.2w' },
  { id: 'h-06', rank: 6, title: '羽绒服充绒量抽检', delta: 'up', heat: '5.7w' },
  { id: 'h-07', rank: 7, title: '户外剧本式求救', delta: 'flat', heat: '5.1w' },
  { id: 'h-08', rank: 8, title: '番位海报被指P图', delta: 'down', heat: '4.6w' },
  { id: 'h-09', rank: 9, title: '美食后厨卫生跟拍', delta: 'up', heat: '4.2w' },
  { id: 'h-10', rank: 10, title: '探店博主摆拍踩雷', delta: 'down', heat: '3.8w' },
];

export interface CategoryEntry {
  id: string;
  name: string;
  en: string;
  desc: string;
  count: string;
  tone: 'primary' | 'accent' | 'secondary';
  icon: string;
}

export const categories: CategoryEntry[] = [
  { id: 'c-01', name: '网红档案', en: 'INFLUENCERS', desc: '素人考古、人设对照、流量翻车全收录', count: '3268 条', tone: 'primary', icon: 'ri-camera-lens-line' },
  { id: 'c-02', name: '主播档案', en: 'STREAMERS', desc: '直播言行、违约仲裁、连麦现场逐句留档', count: '1840 条', tone: 'accent', icon: 'ri-live-line' },
  { id: 'c-03', name: '艺人档案', en: 'CELEBRITIES', desc: '声明核对、演出争议、番位与通告时间线', count: '974 条', tone: 'secondary', icon: 'ri-mic-line' },
  { id: 'c-04', name: '带货档案', en: 'E-COMMERCE', desc: '品控抽检、售后口风、退换货争议链', count: '2206 条', tone: 'primary', icon: 'ri-shopping-bag-3-line' },
  { id: 'c-05', name: '商战档案', en: 'BIG BIZ', desc: '机构对峙、解约仲裁、公会榜单纠纷', count: '688 条', tone: 'accent', icon: 'ri-team-line' },
  { id: 'c-06', name: '塌房预警', en: 'WATCHLIST', desc: '高热度未定论事件实时跟进的动态追踪位', count: '132 条', tone: 'secondary', icon: 'ri-alarm-warning-line' },
];

export interface DigestEntry {
  id: string;
  no: string;
  subject: string;
  tag: string;
  headline: string;
  points: string[];
  updated: string;
}

export const digestList: DigestEntry[] = [
  {
    id: 'd-01',
    no: '盘点 001',
    subject: '晚风几重',
    tag: '带货',
    headline: '一条承诺换三套说辞，七天售后时间线全还原',
    points: ['直播当晚：口头承诺“假一赔十”，回放仍可查。', '第三天：客服口径转称“仅限质量问题”。', '第七天：拉黑相关关键词，删帖前留痕已存档。'],
    updated: '今天更新',
  },
  {
    id: 'd-02',
    no: '盘点 002',
    subject: '陆川叙',
    tag: '艺人',
    headline: '录音三段式复盘：说了什么、传成了什么、声明回应了什么',
    points: ['原话 vs 转述：三处断章重点已逐句标注。', '时间与现场：档期与演出日期存在明显冲突。', '声明核对：通篇未正面回应两处核心指控。'],
    updated: '昨天更新',
  },
  {
    id: 'd-03',
    no: '盘点 003',
    subject: 'MCN 解约潮',
    tag: '商战',
    headline: '机构与主播的话语权之争，今年都在争什么',
    points: ['账号归属：运营方与主播贡献的认定差异。', '违约金：从“天价”到“可谈”的真实判例。', '新人条款：一页合同里的九个风险点速查。'],
    updated: '本周专题',
  },
];

export const tickerFeeds = [
  '快讯 · 晚风几重售后第七天反转',
  '快讯 · 陆川叙工作室发声明否认录音',
  '快讯 · 老K不K宣布下月复播',
  '快讯 · 两家MCN互发律师函',
  '快讯 · 一只柠檬素人访谈被扒',
  '快讯 · 户外“剧本式”求救主播停播自省',
];